import { MissionData } from '../blocks/mission'

// To add missions, import them here and add them to the `missions` object below.
// ミッションを追加するには、ここでインポートして、以下の `missions` オブジェクトに追加します。
import rjf01 from './RJF_01'
import rjf02 from './RJF_02'
import rjf03 from './RJF_03'
import rjf04 from './RJF_04'
import rjf05 from './RJF_05'
import rjf06 from './RJF_06'
import rjf07 from './RJF_07'
import rjf08 from './RJF_08'
import rjf09 from './RJF_09'
import rjf10 from './RJF_10'
import rjf11 from './RJF_11'
import rjf12 from './RJF_12'
import rjs01 from './RJS_01'
import rjs02 from './RJS_02'
import rjs03 from './RJS_03'
import rjs04 from './RJS_04'
import rjs05 from './RJS_05'
import rjs06 from './RJS_06'
import rjs07 from './RJS_07'
import rjs08 from './RJS_08'
import rjs09 from './RJS_09'
import rjs10 from './RJS_10'
import rjs11 from './RJS_11'
import rjs12 from './RJS_12'
import rjf01_trial from './RJF_01_trial'
import event01 from './Event_01'

//Note: 設定値は以下のように設定してください
// サイト名 > ステージのCode（e.g. rb1,rb2...etc) : MissionData
// ローカルで試すにはDB確認後、http://localhost:8008/?projectId=<ミッションID> またはhttp://localhost:8008/?missionId=<ミッションID> にアクセスしてください
const missionProjects: Record<string, Record<string, MissionData>> = {
  online: {
    rb1_1: rjf01,
    rb1_2: rjf02,
    rb1_3: rjf03,
    rb1_4: rjf04,
    rb1_5: rjf05,
    rb1_6: rjf06,
    rb1_7: rjf07,
    rb1_8: rjf08,
    rb1_9: rjf09,
    rb1_10: rjf10,
    rb1_11: rjf11,
    rb1_12: rjf12,
    rb2_1: rjs01,
    rb2_2: rjs02,
    rb2_3: rjs03,
    rb2_4: rjs04,
    rb2_5: rjs05,
    rb2_6: rjs06,
    rb2_7: rjs07,
    rb2_8: rjs08,
    rb2_9: rjs09,
    rb2_10: rjs10,
    rb2_11: rjs11,
    rb2_12: rjs12,
    event_1: event01,
  },
  license: {
    // rj1_trial_0: OP,
    rj1_trial_1: rjf01_trial,
    // rj1_trial_2: Ed,
    // rj1_trial_3: SetUp,
    rj1_2: rjf02,
    rj1_3: rjf03,
    rj1_4: rjf04,
    rj1_5: rjf05,
    rj1_6: rjf06,
    rj1_7: rjf07,
    rj1_8: rjf08,
    rj1_9: rjf09,
    rj1_10: rjf10,
    rj1_11: rjf11,
    rj1_12: rjf12,
    rj2_1: rjs01,
    rj2_2: rjs02,
    rj2_3: rjs03,
    rj2_4: rjs04,
    rj2_5: rjs05,
    rj2_6: rjs06,
    rj2_7: rjs07,
    rj2_8: rjs08,
    rj2_9: rjs09,
    rj2_10: rjs10,
    rj2_11: rjs11,
    rj2_12: rjs12,
  },
}

export default missionProjects
